import Fetch from '../utils/fetch';
import { settings } from '../settings';
import { useCallback, useEffect, useState } from 'react';

export type OrderHistory = {
  orderId: string;
  userId: string;
  userName: string;
  createdAt: string;
  operation: string;
  oldValue: string;
  newValue: string;
};

interface OrderHistorySuccess {
  success: true;
  orderHistory: OrderHistory[];
}

interface OrderHistoryFailure {
  success: false;
  errorMessage: string;
}

type OrderHistoryResult = OrderHistorySuccess | OrderHistoryFailure;

async function orderAPIFetchOrderHistory(
  orderId: string
): Promise<OrderHistoryResult> {
  try {
    const response = await Fetch.get({
      url: `${settings.newApiUrl}/order/orderHistory/${orderId}`,
    });
    if (!response.ok) {
      return {
        success: false,
        errorMessage:
          'Something went wrong. The orderHistory could not be fetched',
      };
    }
    return { success: true, orderHistory: await response.json() };
  } catch (e) {
    return {
      success: false,
      errorMessage: 'Error fetching orderHistory info',
    };
  }
}

export const useOrderHistory = (orderId: string): OrderHistoryResult => {
  const [orderHistoryResult, setOrderHistoryResult] =
    useState<OrderHistoryResult>({ success: true, orderHistory: [] });
  const fetchOrderHistory = useCallback(() => {
    orderAPIFetchOrderHistory(orderId)
      .then(setOrderHistoryResult)
      .catch(e => console.error(e));
  }, [orderId]);
  useEffect(() => {
    fetchOrderHistory();
  }, [fetchOrderHistory]);
  return orderHistoryResult;
};
